export const changeSaleTypeReducer = (state = ' ', action) => {
    switch (action.type) {
      case "CHANGE_SALE_TYPE":
        return action.payload.saleType;
      default:
        return state;
    }
  };
  